import { Drawer } from 'antd'
import FilterForm from './FilterForm'
import DrawerTitle from '../../../../shared/DrawerTitle'

const FilterDrawer = (props) => {
    const { stateTestRun, setStateTestRun = () => {}, projectId } = props
    const isOpen = stateTestRun?.filterDrawer || false

    const handleClose = () => {
        setStateTestRun({ ...stateTestRun, filterDrawer: false })
    }

    return (
        <Drawer
            placement="right"
            width={700}
            rootClassName="testReportDrawer"
            closeIcon={null}
            open={isOpen}
            title={<DrawerTitle title="Filter" onClose={handleClose} />}
        >
            <FilterForm
                stateTestRun={stateTestRun}
                setStateTestRun={setStateTestRun}
                handleClose={handleClose}
                projectId={projectId}
            />
        </Drawer>
    )
}

export default FilterDrawer
